import React, { memo, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

/* components */
import Banner from 'pages/sheared/Banner'
import MainBannerInner from 'pages/Home/MainBannerInner'
import TwamMission from 'pages/Home/TwamMission'
import Categories from 'pages/sheared/Categories'
import Missions from 'pages/sheared/Missions'
import InfoBlock from 'pages/sheared/InfoBlock'
import Testimonials from 'pages/sheared/Testimonials'
import DoubleOffer from 'components/ui/Offers/DoubleOffer'

/* types */
import { propTypes as propTypesMissionList } from 'modules/mission/store/types'
import { propTypes as propTypesTestimonialsList } from 'modules/testimonials/store/types'

/* selectors */
import { getMissionsList } from 'modules/missionsList/store/selectors'
import { getTestimonialsList } from 'modules/testimonials/store/selectors'

/* hooks */
import _useDidMount from 'hooks/lifecycle/use-did-mount'

/* actions */
import { getMissionsListAction } from 'modules/missionsList/store/actions'
import { getTestimonialsListAction } from 'modules/testimonials/store/actions'

/* assets */
import bannerPrimary from 'assets/images/banners/banner_homepage_bg.jpg'
import bannerSecondary from 'assets/images/backgroundSectionTwamMission.jpg'
import bannerTryTwaming from 'assets/images/try-twaming-platform.jpg'
import bannerGroup from 'assets/images/volunteer-as-a-group.jpg'

/* style */
import classes from './index.module.scss'
import _useDidUpdate from '../../hooks/lifecycle/use-did-update'


const HomePage = ({ getMissionsList, missionsList, getTestimonialsList, testimonialsList }) => {
  const [isLoading, setIsLoading] = useState(false)

  _useDidMount(() => {
    getMissionsList({ count: 12 })
    setIsLoading(true)
    getTestimonialsList()
  })

  _useDidUpdate(() => {
    setIsLoading(false)
  }, [missionsList])

  return (
    <>
      <Banner backgroundUrl={bannerPrimary} rounded>
        <MainBannerInner />
      </Banner>

      <Categories />

      <Banner backgroundUrl={bannerSecondary} spacing="medium">
        <TwamMission />
      </Banner>
      {!isLoading && missionsList.length && (
        <Missions
          items={missionsList}
          title="homePageMissionsList"
          titleSpacing="my-12"
        />
      )}


      <InfoBlock
        imageUrl={bannerTryTwaming}
        title="infoBlockTwamingPlatform"
        subtitle="infoBlockTwamingPlatformSubtitle"
        text="infoBlockFirstText"
        buttonText="goToTwamLink"
        buttonLink="https://www.twaming.org/"
        isExternalLink
      />

      <div className="container">
        <div className={classes.doubleOffer}>
          <DoubleOffer />
        </div>
      </div>


      {testimonialsList.length && (
        <Testimonials
          items={testimonialsList}
        />
      )}
      <InfoBlock
        reverse
        imageUrl={bannerGroup}
        title="infoBlockTwamOrganizing"
        text="infoBlockSecondText"
        buttonText="learnMoreLink"
        buttonLink="https://volontariat.travelwithamission.org"
        isExternalLink
      />
    </>
  )
}

HomePage.propTypes = {
  getMissionsList: PropTypes.func.isRequired,
  getTestimonialsList: PropTypes.func.isRequired,
  missionsList: PropTypes.arrayOf(PropTypes.shape(propTypesMissionList)).isRequired,
  testimonialsList: PropTypes.arrayOf(PropTypes.shape(propTypesTestimonialsList)).isRequired,
}

const mapStateToProps = (state) => ({
  missionsList: getMissionsList(state),
  testimonialsList: getTestimonialsList(state),
})

const actionsToProps = {
  getMissionsList: getMissionsListAction,
  getTestimonialsList: getTestimonialsListAction,
}

export default connect(mapStateToProps, actionsToProps)(memo(HomePage))
